exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".role-select .ant-select-selection {\n  background: transparent;\n  color: white;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  min-width: 150px;\n  outline: none;\n  border-color: transparent;\n}\n.role-select .ant-select-selection i {\n    color: white;\n}\n.role-select .ant-select-selection > div {\n    margin-left: 0;\n}\n", ""]);

// exports
